module.exports = __webpack_public_path__ + "static/Honest Food Company-8cdc6533a46820938379fb8fd9c737ee.jpg";